import { AlertTriangle, Info } from "lucide-react";

export function DepositDisclaimer() {
  return (
    <div
      data-testid="deposit-disclaimer"
      className="rounded-2xl border border-blue-500/30 bg-blue-500/[0.06] p-5 flex gap-3 backdrop-blur"
    >
      <AlertTriangle className="w-5 h-5 text-blue-300 shrink-0 mt-0.5" strokeWidth={1.7} />
      <p className="text-sm text-gray-200 leading-relaxed">
        <span className="text-white font-medium">Important:</span> A 10% non-refundable
        deposit is required before work begins. The remaining 90% balance will be
        invoiced through Stripe upon project completion and must be paid before
        launch, deployment, or transfer of final deliverables.
      </p>
    </div>
  );
}

export function FormNotice() {
  return (
    <div
      data-testid="form-required-notice"
      className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 flex gap-3 backdrop-blur"
    >
      <Info className="w-5 h-5 text-blue-300 shrink-0 mt-0.5" strokeWidth={1.7} />
      <p className="text-sm text-gray-300 leading-relaxed">
        <span className="text-white font-medium">All fields are required.</span>{" "}
        If a question does not apply to your project or you do not currently
        know the answer, please enter <span className="text-blue-300">"N/A"</span>{" "}
        or <span className="text-blue-300">"Unknown"</span>.
      </p>
    </div>
  );
}
